<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="title"
    :show-close="true"
    :close-on-click-modal="false"
    width="800px"
    @close="closeDialog"
  >
    <div class="flex justify-sp">
      <div>
        <input
          id="cardCode"
          ref="cardCode"
          v-model="cardCodeNum"
          class="hidden-input"
          inputmode="none"
          type="text"
        />
        <div class="flex gap-5 align-c" style="gap: 6px">
          {{ 'Vui lòng tap ' }}
          <span class="bold">{{ totalCard }}</span>
          {{ ' thẻ' }}
        </div>
      </div>
      <div class="card-number-status flex gap-0 column align-end">
        <div>
          Số lượng thẻ hợp lệ:
          <span class="normal" :class="{ legal: rows.length === totalCard }"
            >{{ rows.length }}/{{ totalCard }}</span
          >
        </div>
        <!-- <div>
          Số lượng thẻ không hợp lệ: <span class="illegal">{{ errorCardNum }}</span>
        </div> -->
      </div>
    </div>
    <div style="height: 300px">
      <GridVx
        ref="agGridAddCardDialog"
        dom-layout="scroll"
        class="my-10 agGrid"
        :columns="cols"
        :rows="rows"
        :context="context"
        :auto-size-cell="true"
      />
    </div>
    <span
      slot="footer"
      class="dialog-footer flex justify-end"
      style="gap: 10px"
    >
      <button class="btn primary small outline" @click="emptyRows">
        Xoá dữ liệu
      </button>
      <button
        :disabled="rows.length !== totalCard"
        type="primary"
        class="btn primary small"
        @click="onAddNew()"
      >
        Xuất vé
      </button>
    </span>
  </el-dialog>
</template>

<script>
import CellRenderDeleteIcon from '@/components/resources/booking/components/CellRenderDeleteIcon.vue'
import { debounceFn } from '@/utils/helper'
import {
  exportCard
  // checkin
} from '@/api/reception/reception'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon
  },
  data() {
    return {
      data: null,
      context: null,
      title: 'Xuất vé cho khách',
      dialogVisible: false,
      tickets: [],
      totalCardNum: 0,
      submitForm: [],
      requiredTicketNum: null,
      cols: [
        {
          headerName: 'STT',
          field: 'stt',
          cellClass: 'grid-cell-centered',
          headerClass: 'header-cell-center',
          maxWidth: 60,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        },
        {
          headerName: 'Mã thẻ',
          field: 'cardNum',
          width: 80
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          cellStyle: params => {
            if (params?.data.status === 'Thẻ hợp lệ') {
              return {
                color: 'green',
                fontWeight: 600
              }
            } else {
              return {
                color: 'red',
                fontWeight: 600
              }
            }
          },
          width: 150
        },
        {
          headerName: '',
          cellRenderer: 'CellRenderDeleteIcon',
          cellClass: 'grid-cell-centered',
          maxWidth: 60,
          minWidth: 60
        }
      ],
      rows: [],
      cardCode: null,
      cardCodeNum: null,
      errorCardNum: null
    }
  },
  // data
  computed: {
    totalCard() {
      return (
        (this.data?.ticket_number_of_adults || 0) +
        (this.data?.ticket_number_of_children || 0)
      )
    }
  },
  watch: {
    cardCodeNum: {
      handler() {
        if (this.cardCodeNum) {
          console.log(this.cardCodeNum)
          debounceFn(() => {
            const newObj = {
              stt: this.rows.length + 1,
              cardNum: this.cardCodeNum,
              status: 'Thẻ hợp lệ'
            }
            if (this.onValidateCard(this.cardCodeNum)) {
              // rows.push(newObj)
              this.rows = [...this.rows, newObj]
              // console.log('aaaaa', this.rows)
            } else {
              // do nothing
            }
            this.cardCodeNum = null
          }, 100)
        }
      }
    },
    dialogVisible: {
      handler() {
        if (this.dialogVisible) {
          this.focusInput()
        }
      }
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      if (this.dialogVisible) {
        this.focusInput()
      }
    })
  },

  // methods
  methods: {
    openDialog(rows) {
      console.log('biwennn', rows)
      this.data = rows
      this.dialogVisible = true
    },

    async onAddNew() {
      const payload = {
        booking_id: this.data.sub_booking_group_id,
        package_group_id: this.data.package_group_id,
        ticket_numbers: this.rows.map(item => item.cardNum)
      }
      await exportCard(payload)
        .then(res => {
          console.log({
            message: 1,
            type: 'success'
          })
          this.dialogVisible = false
          this.$emit('addSuccess')
        })
        .catch(error => {
          const message = error.response?.data?.message ?? 'default'
          this.$message({
            message: message,
            type: 'error'
          })
        })
    },
    focusInput() {
      setTimeout(() => {
        document.getElementById('cardCode').focus()
      }, 100)
    },
    closeDialog() {
      this.rows = []
      this.errorCardNum = 0
    },
    onValidateCard(num) {
      let output = true
      const ids = this.rows.map(item => item.cardNum)
      console.log('ids: ', ids)
      if (ids.includes(num)) {
        this.$message({
          message: 'Thẻ đã bị trùng',
          type: 'error'
        })
        this.errorCardNum++
        output = false
      } else {
        // do nothing
      }
      return output
    },
    emptyRows() {
      this.rows = []
      this.focusInput()
    },
    onDeleteIconClicked(params) {
      console.log('de le te')
      var tempRows = this.rows.filter(item => item.stt !== params.data.stt)
      tempRows = tempRows.map((item, index) => {
        return {
          ...item,
          stt: index + 1
        }
      })
      this.rows = tempRows
    }
  }
}
</script>
<style lang="scss" scoped>
.legal {
  font-weight: 600;
  color: #357456 !important;
  font-size: 16px;
}
.illegal {
  font-weight: 600;
  color: red;
  font-size: 16px;
}
.normal {
  font-weight: 600;
  font-size: 16px;
}
.total-card-wrapper {
  width: 60px;
  text-align: center;
  display: inline-block;
  border-radius: 5px;
  background-color: #edf5f1;
  font-weight: 600;
  color: #357456;
  font-size: 16px;
}
.card-number-status {
  background-color: #e7f6e500;
  padding: 0 5px;
  font-size: 15px;
}

.hidden-input {
  position: fixed;
  left: -10000px;
  top: 0;
}
.flex {
  display: flex;
}
.justify-sp {
  justify-content: space-between;
}
</style>
